<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>

    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="dataCuadrillaForm">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Usuario</mat-label>
                    <input name="user_name" formControlName="user_name" matInput maxlength="200" required >
                </mat-form-field>
            </div>

            <div fxLayout="row" class="textarea-wrapper" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>Coordenadas - Latitud</mat-label>
                    <input matInput type="number" name="geolocation_lat" formControlName="geolocation_lat" required >
                    <mat-error *ngIf="dataCuadrillaForm.get('geolocation_lat').hasError('required')">
                        Latitud es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="dataCuadrillaForm.get('geolocation_lat').hasError('pattern')">
                        Latitud tiene un <strong>formato</strong> incorrecto
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>Coordenadas - Longitud</mat-label>
                    <input matInput type="number" name="geolocation_long" formControlName="geolocation_long" required >
                    <!--<mat-icon matSuffix class="secondary-text">account_circle</mat-icon>-->
                    <mat-error *ngIf="dataCuadrillaForm.get('geolocation_long').hasError('required')">
                        Longitud es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="dataCuadrillaForm.get('geolocation_long').hasError('pattern')">
                        Longitud tiene un <strong>formato</strong> incorrecto
                    </mat-error>
                </mat-form-field>
            </div>
            <agm-map [latitude]="lat" [longitude]="lng">
                <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
            </agm-map>

            <h3>Evidencia</h3>
            <img [src]="imageToShow" class="elementos-img">
        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
    </div>

</div>
